var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goals"},[_c('main-title',{attrs:{"text":"Goals","icon":"menu/menu-goals"}}),_c('ui-text',{staticClass:"intro",attrs:{"text":_vm.logged_user.role.goals}}),_c('goals-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }